import { useContext } from 'react';

import { MobileContext } from 'context';
import { useGameDetails } from 'utils/Hooks';

export function DogeChainDisclaimer(props) {
  const isMobile = useContext(MobileContext);
  const gameDetails = useGameDetails();
  const onDogeChain = (gameDetails.wantedChain.name == 'dogechain') 

  if (onDogeChain)
    return (<p className={'DogeChainDisclaimer' + (isMobile ? ' Mobile' : '')}>
      DogeChain RPCs are not stable. There can be more canceled(refunded) rounds than usual.
      {/*
      Predictions on DogeChain are in beta.  
      Due to the rapid growth of DogeChain, its RPCs often become unresponsive and suffer from downtimes.
      Some rounds can take extra-long time to close. Others might hang and have to be canceled completely.
      You will always get refunded for canceled rounds. But refund is not a win. Play at your own risk.
      */}
    </p>);
  else
    return null;
}
